<template>
    <OnboardingLayout v-bind="appSharedData.getOnboardingLayoutProps()">
        <template #content>
            <OnboardingStepContainer
                :showStepsIndicator="false"
                :stepNumber="1"
            >
                <template #content>
                    <div class="max-w-xl mx-auto">
                        <Card
                            noColors
                            paddingSize="none"
                        >
                            <template #content>
                                <div class="space-y-6">
                                    <div
                                        class="flex flex-col items-center justify-center space-y-4"
                                    >
                                        <Badge
                                            color="info-ghost"
                                            size="medium"
                                        >
                                            Best for coaches, consultants, and
                                            solo experts
                                        </Badge>
                                        <OnboardingStepContainerTitle>
                                            Let's get your booking page live!
                                        </OnboardingStepContainerTitle>
                                        <OnboardingStepContainerSubtitle>
                                            This takes about 2 minutes. You can
                                            publish first and finish details
                                            like calendar connection or branding
                                            later.
                                        </OnboardingStepContainerSubtitle>
                                    </div>
                                    <div class="space-y-2">
                                        <OnboardingStepWelcomeItemCard
                                            iconName="check"
                                        >
                                            Create your booking page
                                        </OnboardingStepWelcomeItemCard>
                                        <OnboardingStepWelcomeItemCard
                                            iconName="calendar"
                                        >
                                            Set simple availability
                                        </OnboardingStepWelcomeItemCard>
                                        <OnboardingStepWelcomeItemCard
                                            iconName="plug"
                                        >
                                            Connect your calendar
                                        </OnboardingStepWelcomeItemCard>
                                        <OnboardingStepWelcomeItemCard
                                            iconName="link"
                                        >
                                            Share one clean link
                                        </OnboardingStepWelcomeItemCard>
                                    </div>
                                </div>
                            </template>
                        </Card>
                    </div>
                </template>
            </OnboardingStepContainer>
        </template>

        <template #footerRight>
            <div>
                <ApiForm
                    method="POST"
                    :url="RoutePathAppEnum.Onboarding_Step1_Welcome"
                    ref="apiFormRef"
                >
                    <Button
                        @click="apiFormRef?.submit()"
                        iconName="arrow-right"
                        color="primary"
                        :iconRight="true"
                        :loading="apiFormRef?.loading.valueOf()"
                        :disabled="apiFormRef?.loading.valueOf()"
                    >
                        Continue
                    </Button>
                </ApiForm>
            </div>
        </template>
    </OnboardingLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import OnboardingLayout from '@/Shared/Layout/Onboarding/OnboardingLayout.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import OnboardingStepContainer from '@/App/Company/Component/OnboardingStepContainer.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import Badge from '@/Shared/Component/Badge.vue'
    import Card from '@/Shared/Component/Card.vue'
    import OnboardingStepContainerTitle from '@/App/Company/Component/OnboardingStepContainerTitle.vue'
    import OnboardingStepContainerSubtitle from '@/App/Company/Component/OnboardingStepContainerSubtitle.vue'
    import OnboardingStepWelcomeItemCard from '@/App/Company/Component/OnboardingStepWelcomeItemCard.vue'

    interface ShowOnboardingStepWelcomeProps {
        appSharedDataData: any
    }

    const props = defineProps<ShowOnboardingStepWelcomeProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const apiFormRef = ref<ApiFormRefType>(null)
</script>
